__turbopack_context__.v({
  "amountInput": "XG0Mya_amountInput",
  "cell": "XG0Mya_cell",
  "cellBig": "XG0Mya_cellBig",
  "image": "XG0Mya_image",
  "name": "XG0Mya_name",
  "nameAndAmount": "XG0Mya_nameAndAmount",
  "oldPrice": "XG0Mya_oldPrice",
  "priceAndPromo": "XG0Mya_priceAndPromo",
  "promo": "XG0Mya_promo",
  "promoDays": "XG0Mya_promoDays",
  "promoText": "XG0Mya_promoText",
  "scratchedPrice": "XG0Mya_scratchedPrice",
  "specialPromo": "XG0Mya_specialPromo",
});
